import React from 'react';
import cn from '../utils/cn';

type KoobKanbanColumnProps = {
  /** Accent color (any CSS color) used for the top border + status dot. */
  color: string;
  title: React.ReactNode;
  count?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
};

/**
 * A single kanban column: accent-topped card with a dot + title + count header
 * and a scrollable body. Grouping/ordering is the caller's job.
 */
export default function KoobKanbanColumn({
  color,
  title,
  count,
  children,
  className,
}: KoobKanbanColumnProps) {
  return (
    <div
      className={cn(
        'flex w-72 shrink-0 flex-col rounded-xl border border-t-4 border-solid border-border bg-card',
        className,
      )}
      style={{ borderTopColor: color }}
    >
      <div className="flex items-center gap-2 border-0 border-b border-solid border-border px-4 py-3">
        <span
          className="h-2.5 w-2.5 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
        <span className="truncate text-sm font-semibold text-foreground">
          {title}
        </span>
        {count != null && (
          <span className="ml-auto rounded-full bg-muted px-2 py-0.5 text-xs font-medium tabular-nums text-muted-foreground">
            {count}
          </span>
        )}
      </div>
      <div className="max-h-[60vh] space-y-2 overflow-y-auto p-2">
        {children}
      </div>
    </div>
  );
}
